export const tableFields = [
  { field: 'state_numbers', name: 'Гос.номер', action: null },
  { field: 'ttn_numbers', name: 'Номер ТТН', width: 90, action: null },
  { field: 'act_number', name: 'АКТ', width: 100, action: null },
  { field: 'act_date', name: 'Дата АКТа', width: 90, action: null },
  {
    field: 'carrier_inn',
    name: 'ИНН получателя',
    width: 100,
    action: null,
  },
  {
    field: 'carrier_name',
    name: 'Наименование получателя',
    width: 140,
    action: null,
  },
  {
    field: 'payment_number',
    name: 'Номер платежки',
    width: 60,
    action: null,
  },
  {
    field: 'payment_date',
    name: 'Дата платежки',
    width: 100,
    action: null,
  },
  {
    field: 'payment_status',
    name: 'Статус платежа',
    width: 100,
    action: null,
  },
  {
    field: 'updated_at',
    name: 'Дата изменения статуса',
    width: 100,
    action: null,
  },
  { field: 'sum', name: 'Сумма', width: 60, action: 'sum' },
  { field: 'comment', name: 'Комментарий', width: 100, action: 'comment' },
  {
    field: 'file_link',
    name: 'Ссылка на файл',
    width: 100,
    action: 'file_link',
  },
]

export const paymentsStatusFilter = [
  { name: 'запрос платежа', val: 1 },
  { name: 'сформирован платеж', val: 0 },
  { name: 'отправлен в банк', val: 2 },
  { name: 'оплачен', val: 3 },
  { name: 'отменен', val: 4 },
  { name: 'ошибка из банка', val: 5 },
]

export const paymentsStatus = {
  1: 'запрос платежа',

  0: 'сформирован платеж',

  2: 'отправлен в банк',

  3: 'оплачен',

  4: 'отменен',

  5: 'ошибка из банка',
}

export const perPageOptions = [50, 100, 200, 500, 1000]

export const dateFilters = [
  { field: 'date_from', text: 'дата с' },
  { field: 'date_to', text: 'дата по' },
]

export const paymentMenuItems = [
  {
    name: 'DownloadPaymentsFromBank',
    title: 'Выгрузить в банк ',
    type: 'modal',
    typePayment: 0,
    button: 'Выгрузить',
  },
  {
    name: 'SendAllPaymentsToBank',
    title: 'Отправить все неоплаченные в банк',
    type: 'modal',
    typePayment: 1,
    button: 'Отправить',
  },
  {
    name: 'UploadSuccessPaymentsFromBank',
    title: 'Загрузить успешные платежи',
    type: 'modal',
    typePayment: 3,
    button: 'Загрузить',
  },
  {
    name: 'UploadFailPaymentsFromBank',
    title: 'Загрузить не успешные платежи',
    type: 'modal',
    typePayment: 5,
    button: 'Загрузить',
  },
]
